const storageKey = 'measurement-unit';

export default function measurementUnitStore() {
    return {
        mode: localStorage.getItem(storageKey) || 'imperial',
        setMode(mode) {
            this.mode = mode === 'metric' ? 'metric' : 'imperial';
            localStorage.setItem(storageKey, this.mode);
        },
        toggle() {
            this.setMode(this.mode === 'imperial' ? 'metric' : 'imperial');
        },
    };
}
